import * as Sentry from "@sentry/react";

import { signIn } from "../../api/services/auth";
import {
  CLIENT_CREDETIONAL_GRANT_TYPE,
  PASSWORD_GRANT_TYPE,
  REFRESH_TOKEN_GRANT_TYPE,
} from "../../api/services/auth/constants";
import { ILoginResponse } from "../../api/services/auth/models";
import { getMyInfo } from "../../api/services/profile";
import { AppLogin, contextUserLogin, setUserProfileInfo } from "../authContext";
import { AuthConfig } from "../config/authConfig";
import { EVENT_LOCAL_STORAGE_UPDATE_MY_INFO } from "../events";

export const setAppToken = async () => {
  const credentials = new FormData();
  credentials.append("grant_type", CLIENT_CREDETIONAL_GRANT_TYPE);
  try {
    const res: ILoginResponse = await signIn(credentials);
    AppLogin(res);
    return res;
  } catch (err) {
    Sentry.captureException(err);
    console.log(err);
  }
};
export const loginUser = (credentials: FormData) => {
  credentials.append("grant_type", PASSWORD_GRANT_TYPE);
  return signIn(credentials);
};
export const fetchAndSetMyInfo = async () => {
  const myInfo = await getMyInfo();
  setUserProfileInfo(myInfo.data);
  window.dispatchEvent(new Event(EVENT_LOCAL_STORAGE_UPDATE_MY_INFO));
};

export const setRefreshToken = async () => {
  const credentials = new FormData();
  credentials.append("grant_type", REFRESH_TOKEN_GRANT_TYPE);
  credentials.append("refresh_token", AuthConfig.getRefreshToken() || "");
  try {
    const res: ILoginResponse = await signIn(credentials);
    contextUserLogin(res);
  } catch (err) {
    console.log(err);
  }
};
